module.exports = __webpack_public_path__ + "img/yoga-mat.7234c991.svg";